<ng-container *ngIf="movements != null">
    <form [formGroup]="form">
        <div class="table-container">
            <div class="table-content" formArrayName="movements">
                <div class="header">
                    <div class="header-cell"></div>
                    <div class="header-cell" *ngIf="tableType === 'COSTS' || tableType === 'DEPRECIATION'">
                        {{ colTitles[0] | i18nextWithLocale : reportLocale }} {{ newPeriodDate | dateLocale }}
                    </div>
                    <div class="header-cell" *ngIf="tableType === 'VALUE APPRECIATION'">
                        {{ colTitles[0] | i18nextWithLocale : reportLocale }}
                    </div>
                    <div class="header-cell" *ngIf="tableType === 'COSTS' || tableType === 'DEPRECIATION'">
                        {{ colTitles[1] | i18nextWithLocale : reportLocale }}
                    </div>
                    <div class="header-cell" *ngIf="tableType === 'COSTS' || tableType === 'DEPRECIATION'">
                        {{ colTitles[2] | i18nextWithLocale : reportLocale }}
                    </div>
                    <div class="header-cell" *ngIf="tableType === 'COSTS' || tableType === 'DEPRECIATION'">
                        {{ colTitles[3] | i18nextWithLocale : reportLocale }}
                    </div>
                    <div class="header-cell" *ngIf="tableType === 'COSTS' || tableType === 'DEPRECIATION'">
                        {{ colTitles[4] | i18nextWithLocale : reportLocale }} {{ balanceClosingDate | dateLocale }}
                    </div>
                    <div class="header-cell" *ngIf="tableType === 'VALUE APPRECIATION'">
                        {{ colTitles[1] | i18nextWithLocale : reportLocale }} {{ balanceClosingDate | dateLocale }}
                    </div>
                    <div class="header-cell" *ngIf="tableType === 'VALUE APPRECIATION' && !noPreviousData">
                        {{ colTitles[2] | i18nextWithLocale : reportLocale }} {{ balanceOpeningDate | dateLocale }}
                    </div>
                </div>
                <div
                    class="table-content__row"
                    *ngFor="let movement of movements.controls; let i = index"
                    [formGroupName]="i"
                    [ngClass]="getClassForMovement(movement, i)"
                >
                    <div class="cell"><span></span>{{ movement.get('caption').value }}</div>
                    <ng-container *ngIf="tableType === 'COSTS'">
                        <div class="cell" *ngIf="!hasChildren(i)">
                            <aumico-number-input
                                [control]="movement.get('costs').get('openingValue')"
                                class="number-input"
                            >
                            </aumico-number-input>
                        </div>
                        <div class="cell uneditable" *ngIf="hasChildren(i)">
                            <span>
                                {{ movement.get('costs').get('openingValue').value | finNumber }}
                            </span>
                        </div>
                        <div class="cell" *ngIf="!hasChildren(i)">
                            <aumico-number-input
                                [control]="movement.get('costs').get('additions')"
                                class="number-input"
                            >
                            </aumico-number-input>
                        </div>
                        <div class="cell uneditable" *ngIf="hasChildren(i)">
                            <span>
                                {{ movement.get('costs').get('additions').value | finNumber }}
                            </span>
                        </div>
                        <div class="cell" *ngIf="!hasChildren(i)">
                            <aumico-number-input
                                [control]="movement.get('costs').get('disposals')"
                                class="number-input"
                            >
                            </aumico-number-input>
                        </div>
                        <div class="cell uneditable" *ngIf="hasChildren(i)">
                            <span>
                                {{ movement.get('costs').get('disposals').value | finNumber }}
                            </span>
                        </div>
                        <div class="cell" *ngIf="!hasChildren(i)">
                            <aumico-number-input
                                [control]="movement.get('costs').get('transfers')"
                                class="number-input"
                            >
                            </aumico-number-input>
                        </div>
                        <div class="cell uneditable" *ngIf="hasChildren(i)">
                            <span>
                                {{ movement.get('costs').get('transfers').value | finNumber }}
                            </span>
                        </div>
                        <div class="cell uneditable">
                            <span>
                                {{ movement.get('costs').get('closingValue').value | finNumber }}
                            </span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="tableType === 'DEPRECIATION'">
                        <div class="cell" *ngIf="!hasChildren(i)">
                            <aumico-number-input
                                [control]="movement.get('depreciations').get('openingValue')"
                                class="number-input"
                            >
                            </aumico-number-input>
                        </div>
                        <div class="cell uneditable" *ngIf="hasChildren(i)">
                            <span>
                                {{ movement.get('depreciations').get('openingValue').value | finNumber }}
                            </span>
                        </div>
                        <div class="cell" *ngIf="!hasChildren(i)">
                            <aumico-number-input
                                [control]="movement.get('depreciations').get('additions')"
                                class="number-input"
                            >
                            </aumico-number-input>
                        </div>
                        <div class="cell uneditable" *ngIf="hasChildren(i)">
                            <span>
                                {{ movement.get('depreciations').get('additions').value | finNumber }}
                            </span>
                        </div>
                        <div class="cell" *ngIf="!hasChildren(i)">
                            <aumico-number-input
                                [control]="movement.get('depreciations').get('disposals')"
                                class="number-input"
                            >
                            </aumico-number-input>
                        </div>
                        <div class="cell uneditable" *ngIf="hasChildren(i)">
                            <span>
                                {{ movement.get('depreciations').get('disposals').value | finNumber }}
                            </span>
                        </div>
                        <div class="cell" *ngIf="!hasChildren(i)">
                            <aumico-number-input
                                [control]="movement.get('depreciations').get('transfers')"
                                class="number-input"
                            >
                            </aumico-number-input>
                        </div>
                        <div class="cell uneditable" *ngIf="hasChildren(i)">
                            <span>
                                {{ movement.get('depreciations').get('transfers').value | finNumber }}
                            </span>
                        </div>
                        <div class="cell uneditable">
                            <span>
                                {{ movement.get('depreciations').get('closingValue').value | finNumber }}
                            </span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="tableType === 'VALUE APPRECIATION'">
                        <div class="cell" *ngIf="!hasChildren(i)">
                            <aumico-number-input
                                [control]="movement.get('valueAppreciations').get('openingValue')"
                                class="number-input"
                            >
                            </aumico-number-input>
                        </div>
                        <div class="cell uneditable" *ngIf="hasChildren(i)">
                            <span>
                                {{ movement.get('valueAppreciations').get('openingValue').value | finNumber }}
                            </span>
                        </div>
                        <div class="cell uneditable">
                            <span> </span>
                            {{ movement.get('closingValue').value | finNumber }}
                        </div>
                        <div class="cell uneditable" *ngIf="!noPreviousData">
                            <span> </span>
                            {{ movement.get('openingValue').value | finNumber }}
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </form>
</ng-container>
